import pl from "./public_booking/pl.json";
import en from "./public_booking/en.json";

export default { pl, en };
